/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PublicationUrl } from './PublicationUrl';
import {
    PublicationUrlFromJSON,
    PublicationUrlFromJSONTyped,
    PublicationUrlToJSON,
    PublicationUrlToJSONTyped,
} from './PublicationUrl';

/**
 * 
 * @export
 * @interface UpdatePublicationUrlsForCurrentRetailerCommand
 */
export interface UpdatePublicationUrlsForCurrentRetailerCommand {
    /**
     * 
     * @type {Set<PublicationUrl>}
     * @memberof UpdatePublicationUrlsForCurrentRetailerCommand
     */
    publicationUrls: Set<PublicationUrl>;
}

/**
 * Check if a given object implements the UpdatePublicationUrlsForCurrentRetailerCommand interface.
 */
export function instanceOfUpdatePublicationUrlsForCurrentRetailerCommand(value: object): value is UpdatePublicationUrlsForCurrentRetailerCommand {
    if (!('publicationUrls' in value) || value['publicationUrls'] === undefined) return false;
    return true;
}

export function UpdatePublicationUrlsForCurrentRetailerCommandFromJSON(json: any): UpdatePublicationUrlsForCurrentRetailerCommand {
    return UpdatePublicationUrlsForCurrentRetailerCommandFromJSONTyped(json, false);
}

export function UpdatePublicationUrlsForCurrentRetailerCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePublicationUrlsForCurrentRetailerCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'publicationUrls': (new Set((json['publicationUrls'] as Array<any>).map(PublicationUrlFromJSON))),
    };
}

export function UpdatePublicationUrlsForCurrentRetailerCommandToJSON(json: any): UpdatePublicationUrlsForCurrentRetailerCommand {
    return UpdatePublicationUrlsForCurrentRetailerCommandToJSONTyped(json, false);
}

export function UpdatePublicationUrlsForCurrentRetailerCommandToJSONTyped(value?: UpdatePublicationUrlsForCurrentRetailerCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'publicationUrls': (Array.from(value['publicationUrls'] as Set<any>).map(PublicationUrlToJSON)),
    };
}

